import * as React from 'react';

import { StandardDisclaimerContentUI } from './content/StandardDisclaimerUI';
import { HertzDisclaimerContentUI } from './content/HertzDisclaimerUI';

// NOTE: In future this could be exported from this component if it is needed elsewhere
const HERTZ_TEMPLATE_NAME = 'hertz';

export interface IDisclaimerUIStateProps {
    disclaimerTemplateName?: string;
    customLongDisclaimer: string;
    dealerZipCode: string;
    currentDate: string;
    currentFullYear: number;
}

export interface IDisclaimerUIDispatchProps {
}

export type IDisclaimerUIProps = IDisclaimerUIStateProps & IDisclaimerUIDispatchProps;

const DisclaimerUI: React.ComponentType<IDisclaimerUIProps> = (props) => {
    const customLongDisclaimer = props.customLongDisclaimer;
    const dealerDisclaimer = customLongDisclaimer ? (
        <div>
            <h4>Dealer Disclaimer</h4>
        </div>
    ) : null;
    const DisclaimerContentUI =
        props.disclaimerTemplateName === HERTZ_TEMPLATE_NAME ? (
            <HertzDisclaimerContentUI />
        ) : (
            <StandardDisclaimerContentUI
                dealerZipCode={props.dealerZipCode}
                currentDate={props.currentDate}
                currentFullYear={props.currentFullYear}
            />
        );

    return (
        <div className="Disclaimer-container">
            <h1 className="dr-ui-legal-docs-headline">Disclaimers</h1>
            {dealerDisclaimer}
            <div className="custom-disclaimer-long">{customLongDisclaimer}</div>
            {DisclaimerContentUI}
        </div>
    );
};

export default DisclaimerUI;
